import { stats } from '../constants/content';

export default function StatsStrip() {
  return (
    <section className="section section--tight section--dark">
      <div className="container">
        <div className="stats">
          {stats.map((stat) => (
            <div key={stat.label} className="stat">
              <p className="stat__value">{stat.value}</p>
              <p className="stat__label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
